import PackageWarning from './PackageWarning';

export default PackageWarning;
